import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from 'components/shared/error-boundary';
import SiteToaster from 'components/shared/site-toaster';
import { AuthProvider } from 'providers/auth-provider';
import Layout from 'components/layout/layout';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <HelmetProvider>
          <ErrorBoundary>
            <SiteToaster />
            <Helmet defaultTitle="Hutrics" titleTemplate="Hutrics" />
            <Layout />
          </ErrorBoundary>
        </HelmetProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
